(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    try {
      var ctaParam = new URLSearchParams(window.location.search).get('cta');
      if (ctaParam === 'v1') {
        bar.classList.remove('sticky-atc--floating');
        bar.setAttribute('data-sticky-atc-style', 'bar');
      } else if (ctaParam === 'v2') {
        bar.classList.add('sticky-atc--floating');
        bar.setAttribute('data-sticky-atc-style', 'floating');
      }
    } catch (e) {}

    var mainBtn = document.querySelector(
      '.product-info__buy-buttons buy-buttons button[type="submit"]'
    );
    if (!mainBtn) return;

    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (stickyBtn.hasAttribute('disabled')) return;
        mainBtn.click();
      });

      var syncLoadingState = function () {
        var loading =
          mainBtn.hasAttribute('disabled') ||
          mainBtn.getAttribute('aria-busy') === 'true';
        stickyBtn.toggleAttribute('disabled', loading);
        stickyBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      };

      var attrObserver = new MutationObserver(syncLoadingState);
      attrObserver.observe(mainBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-busy'],
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var mainBtnPastViewport = false;
    var footerInView = false;

    var updateVisibility = function () {
      if (mainBtnPastViewport && !footerInView) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    };

    var btnObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var rootBounds = entry.rootBounds;
          mainBtnPastViewport =
            !entry.isIntersecting &&
            rootBounds &&
            entry.boundingClientRect.bottom <= rootBounds.top;
          updateVisibility();
        });
      },
      { threshold: 0 }
    );

    btnObserver.observe(mainBtn);

    var footer = document.querySelector('.footer');
    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
            updateVisibility();
          });
        },
        { threshold: 0 }
      );

      footerObserver.observe(footer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
